/**
 * Module 33 (WP-BG.2) — small, dependency-free HSL/hex colour utilities.
 * HSL is the working model because the Generation Rules are stated in terms of
 * lightness (brightness 70–90%) and saturation ("medium"), which map directly.
 */
export function clamp01(n) {
    return n < 0 ? 0 : n > 1 ? 1 : n;
}
/** Wrap a hue into [0, 360). */
export function wrapHue(h) {
    const m = h % 360;
    return m < 0 ? m + 360 : m;
}
function toHex2(n) {
    return Math.round(clamp01(n) * 255)
        .toString(16)
        .padStart(2, '0');
}
/** HSL → "#rrggbb". h in degrees, s/l in 0..1. */
export function hslToHex({ h, s, l }) {
    const hue = wrapHue(h);
    const c = (1 - Math.abs(2 * l - 1)) * clamp01(s);
    const x = c * (1 - Math.abs(((hue / 60) % 2) - 1));
    const m = l - c / 2;
    let r = 0;
    let g = 0;
    let b = 0;
    if (hue < 60)
        [r, g, b] = [c, x, 0];
    else if (hue < 120)
        [r, g, b] = [x, c, 0];
    else if (hue < 180)
        [r, g, b] = [0, c, x];
    else if (hue < 240)
        [r, g, b] = [0, x, c];
    else if (hue < 300)
        [r, g, b] = [x, 0, c];
    else
        [r, g, b] = [c, 0, x];
    return `#${toHex2(r + m)}${toHex2(g + m)}${toHex2(b + m)}`;
}
/** "#rrggbb" → HSL. */
export function hexToHsl(hex) {
    const clean = hex.replace('#', '');
    const r = parseInt(clean.slice(0, 2), 16) / 255;
    const g = parseInt(clean.slice(2, 4), 16) / 255;
    const b = parseInt(clean.slice(4, 6), 16) / 255;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    const d = max - min;
    let s = 0;
    let h = 0;
    if (d !== 0) {
        s = d / (1 - Math.abs(2 * l - 1));
        if (max === r)
            h = ((g - b) / d) % 6;
        else if (max === g)
            h = (b - r) / d + 2;
        else
            h = (r - g) / d + 4;
        h *= 60;
    }
    return { h: wrapHue(h), s: clamp01(s), l: clamp01(l) };
}
